import React from "react";

function Footer() {
    return (
        <footer className="container">
            <div class="row">
                <div class="footer-card card footer fixed-bottom text-center w-100">
                    <h6 class="card-footer text-muted">&copy;Copyright</h6>
                </div>
            </div>
        </footer>
    )
}

export default Footer;